import common from "./common";
import "../config";
import translationStore from "./v2/translation.store";

class Store {
  common = null;

  constructor(common) {
    this.common = common;
    this.translationStore = translationStore;
  }
}

export default new Store(common);
